import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/api/index';

@Injectable({
    providedIn: 'root'
})
export class CsvSettingsApiService {

    constructor(private readonly baseApiService: BaseApiService) {
    }

    saveCSVSettings(data): Observable<{ response: string }> {
        return this.baseApiService.post('csv/settings', data, { showSuccess: true, showError: true });
    }
}
